import { render, staticRenderFns } from "./ProductRelation.vue?vue&type=template&id=0299f54d"
import script from "./ProductRelation.vue?vue&type=script&lang=js"
export * from "./ProductRelation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports